import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { DateTime } from "luxon";
import { ReverifyAttempt } from "../types";

interface Props {
  selectedReverifyAttempt?: ReverifyAttempt;
}

export const ReverifyInitiatedBy = ({ selectedReverifyAttempt }: Props) => {
  const currentItemReverifyLog = Array.isArray(selectedReverifyAttempt)
    ? selectedReverifyAttempt[0]?.reverify_log
    : selectedReverifyAttempt?.reverify_log;
  if (!Object.keys(currentItemReverifyLog || {}).length) return null;

  return (
    <div className="flex gap-4 items-center mb-2 mt-4 animate-appear">
      <HugeiconsIcon
        icon={InformationCircleIcon}
        className="text-content-200 shrink-0"
        size={20}
      />

      <p className="text-sm font-medium text-content-400">
        Re-verification was initiated by{" "}
        <span className="font-bold text-content-1000">
          {currentItemReverifyLog?.author?.name}
        </span>{" "}
        on{" "}
        <span className="font-bold text-content-1000">
          {DateTime.fromISO(currentItemReverifyLog?.created_at).toFormat(
            "MMM d, yyyy 'at' h:mm a"
          )}
        </span>
      </p>
    </div>
  );
};
